const API_URL = 'https://hamaca.carreticacuentera.com/info';
const LABERINTOS = '/laberintos' ;
const LABERINTOS_SET = '/laberinto_set';
const MEDIA_URL = 'https://hamaca.carreticacuentera.com'


export { API_URL, LABERINTOS, LABERINTOS_SET, MEDIA_URL };